const NAV_GROUPS: Array<{
  label: string
  items: Array<{ label: string; icon: string; to: string }>
}> = [
  {
    label: 'مدیریت مشتریان',
    items: [
      { label: 'نمای کلی', icon: 'i-lucide-layout-dashboard', to: '/admin' },
      { label: 'کاربران', icon: 'i-lucide-users', to: '/admin/users' },
      { label: 'سایت‌ها', icon: 'i-lucide-globe', to: '/admin/sites' },
      { label: 'درخواست دامنه‌ها', icon: 'i-lucide-globe-2', to: '/admin/domain-requests' },
    ],
  },
  {
    label: 'محصول و پلن',
    items: [
      { label: 'ماژول‌ها', icon: 'i-lucide-blocks', to: '/admin/modules' },
      { label: 'پلن‌ها', icon: 'i-lucide-layers', to: '/admin/plans' },
    ],
  },
  {
    label: 'مالی و پشتیبانی',
    items: [
      { label: 'اشتراک‌ها', icon: 'i-lucide-credit-card', to: '/admin/subscriptions' },
      { label: 'پرداخت‌ها', icon: 'i-lucide-banknote', to: '/admin/payments' },
      { label: 'درگاه‌ها', icon: 'i-lucide-landmark', to: '/admin/payment-gateways' },
      { label: 'تیکت‌ها', icon: 'i-lucide-life-buoy', to: '/admin/tickets' },
    ],
  },
  {
    label: 'سیستم',
    items: [
      { label: 'کدهای OTP', icon: 'i-lucide-key-round', to: '/admin/otp' },
      { label: 'قالب‌های پیامک', icon: 'i-lucide-message-square', to: '/admin/sms' },
      { label: 'خطاها و باگ‌ها', icon: 'i-lucide-bug', to: '/admin/error-logs' },
      { label: 'مدیران', icon: 'i-lucide-shield', to: '/admin/admins' },
      { label: 'تنظیمات', icon: 'i-lucide-settings', to: '/admin/settings' },
    ],
  },
]

const NAV_DEFS = NAV_GROUPS.flatMap((group) => group.items)

const BREADCRUMB_LABELS: Record<string, string> = {
  '/admin': 'نمای کلی',
  '/admin/users': 'کاربران',
  '/admin/sites': 'سایت‌ها',
  '/admin/domain-requests': 'درخواست دامنه‌ها',
  '/admin/modules': 'ماژول‌ها',
  '/admin/plans': 'پلن‌ها',
  '/admin/subscriptions': 'اشتراک‌ها',
  '/admin/payments': 'پرداخت‌ها',
  '/admin/payment-gateways': 'درگاه‌ها',
  '/admin/tickets': 'تیکت‌ها',
  '/admin/error-logs': 'خطاها و باگ‌ها',
  '/admin/otp': 'کدهای OTP',
  '/admin/sms': 'قالب‌های پیامک',
  '/admin/admins': 'مدیران',
  '/admin/settings': 'تنظیمات',
}

export function useAdminNav() {
  const route = useRoute()

  const navItems = computed(() =>
    NAV_GROUPS.map((group) => [
      { label: group.label, type: 'label' as const },
      ...group.items.map((item) => ({ ...item })),
    ]),
  )

  const searchGroups = computed(() => [
    {
      id: 'pages',
      label: 'صفحات',
      items: NAV_DEFS.map((d) => ({
        id: d.to,
        label: d.label,
        icon: d.icon,
        to: d.to,
      })),
    },
  ])

  const breadcrumbs = computed(() => {
    const path = route.path.replace(/\/$/, '') || '/admin'
    if (path.startsWith('/admin/sites/') && path !== '/admin/sites') {
      return [
        { label: 'پنل مدیریت', to: '/admin' },
        { label: 'سایت‌ها', to: '/admin/sites' },
        { label: 'جزئیات سایت' },
      ]
    }
    if (path.startsWith('/admin/tickets/') && path !== '/admin/tickets') {
      return [
        { label: 'پنل مدیریت', to: '/admin' },
        { label: 'تیکت‌ها', to: '/admin/tickets' },
        { label: 'جزئیات تیکت' },
      ]
    }
    if (path.startsWith('/admin/error-logs/') && path !== '/admin/error-logs') {
      const isAnalytics = path.endsWith('/analytics')
      return [
        { label: 'پنل مدیریت', to: '/admin' },
        { label: 'خطاها و باگ‌ها', to: '/admin/error-logs' },
        { label: isAnalytics ? 'تحلیل' : 'جزئیات باگ' },
      ]
    }
    const label = BREADCRUMB_LABELS[path] ?? 'پنل مدیریت'
    return [
      { label: 'پنل مدیریت', to: '/admin' },
      { label },
    ]
  })

  return { navItems, searchGroups, breadcrumbs }
}
